import { axiosUpdateHeaders } from '@/http'

const SET_LOADING = 'SET_LOADING'
const SET_ALERT = 'SET_ALERT'
const SET_RESULTS = 'SET_RESULTS'

export const state = {
  results: [],
  loading: false,
  alert: '',
  creditCardByProduct: (process.env.VUE_APP_CREDIT_CARD_BY_PRODUCT === 'false') ? false : true
}

export const mutations = {
  [SET_LOADING] (state) {
    state.loading = !state.loading
  },
  [SET_ALERT] (state, alert) {
    state.alert = alert
  },
  [SET_RESULTS] (state, payload) {
    state.results = payload
  }
}

export const actions = {
  getCreditcards ({ commit }) {
    commit(SET_LOADING)

    const axios = axiosUpdateHeaders()
    return axios.get('/api/cards/').then(response => {
      if (response.status === 200) {
        commit(SET_RESULTS, response.data.results)
      }
      commit(SET_LOADING)
    }).catch(() => {
      /* TODO HANDLE ERROR */
      commit(SET_LOADING)
    })
  },
  postCreditcard ({ commit, dispatch }, data) {
    commit(SET_LOADING)
    commit(SET_ALERT, '')

    const axios = axiosUpdateHeaders()
    return axios.post('/api/cards/', data).then((response) => {
      if (response.status === 200 || response.status === 201) {
        // UPDATE AVAILABLE CARDS
        dispatch('getCreditcards')

        commit(SET_ALERT, 'Cartão criado com sucesso.')
        commit(SET_LOADING)
        return Promise.resolve(response.data)
      }
      return Promise.reject(response.data)
    }).catch(error => {
      /* TODO HANDLE ERROR */
      if (Object.prototype.hasOwnProperty.call(error.response.data, 'message')) {
        commit(SET_ALERT, error.response.data.message)
      }
      commit(SET_LOADING)
      return Promise.reject(error.response.data)
    })
  }
}

export default {
  namespaced : true,
  state,
  mutations,
  actions
  /* getters */
}
